import React from "react"
import PropTypes from "prop-types"

import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export const styleSheet = theme => ({
  root: { padding: [0, theme.spacing.unit * 2] },

  block: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing.unit * 4,
    color: theme.palette.text.secondary,
  },

  table: {
    composes: "$block",
    height: "25vh",
  },

  section: { composes: "$block" },
})

class Loader extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    appearance: PropTypes.oneOf(["default", "section", "table"]),
    loading: PropTypes.bool,
    loadingContent: PropTypes.node,
    updating: PropTypes.bool,
  }

  _renderLoader({
    appearance,
    classes,
    className: classNameProp,
    loading,
    loadingContent,
    updating,

    ...otherProps
  }) {
    const className = classnames(classes.root, classes[appearance], classNameProp)

    return (
      <div {...otherProps} className={className}>
        {loadingContent ? loadingContent : <CircularProgress />}
      </div>
    )
  }

  render() {
    const { appearance, children, loading, updating } = this.props

    if (loading === undefined || loading) {
      return this._renderLoader(this.props)
    }

    let rendered = typeof children === "function" ? children() : React.Children.only(children)

    if (updating) {
      rendered = (
        <React.Fragment>
          {rendered}
          {this._renderLoader({
            ...this.props,
            appearance: appearance !== "default" ? "block" : appearance,
          })}
        </React.Fragment>
      )
    }

    return rendered
  }
}

export default withStyles(styleSheet)(Loader)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Loader/Loader.js